module.exports = __webpack_public_path__ + "img/05.70d8c76d.jpg";